module.exports = __webpack_public_path__ + "img/barcode-scanned.d7c7e14d.svg";